import React, { useState } from 'react';
import { Text, useDisclosure } from '@podiumhq/design-system';
import { useTracking } from '@podiumhq/tracking';

import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';

import { paymentDetailsTitleStyles } from '../../styles';

import SelectPlanTermForm from '../FormItems/SelectPlanTermForm';
import SelectPlanTerm from '../SelectPlanTerm';

import { EditModalWrapper } from './modals';

export const SelectPlanTermSummary = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { selectedTerm, setSelectedTerm } = useSelectPlanCheckoutContext();
  const { trackEvent } = useTracking();

  const [termToUpdate, setTermToUpdate] = useState(selectedTerm);

  const closeModal = () => {
    trackEvent('selectPlanCheckout.selectPlanType.exit');
    onClose();
  };

  const openModal = () => {
    trackEvent('selectPlanCheckout.confirmDetails.selectPlanTypeChangeClicked');
    setTermToUpdate(selectedTerm);
    onOpen();
  };

  const updateSelectedPlanTerm = () => {
    setSelectedTerm && setSelectedTerm(termToUpdate);
    onClose();
  };

  return (
    <>
      <SelectPlanTerm openModal={openModal} />

      <EditModalWrapper
        handleSave={updateSelectedPlanTerm}
        headerTitle="Edit plan type."
        isOpen={isOpen}
        onClose={closeModal}
      >
        <Text color="black.base" {...paymentDetailsTitleStyles}>
          Plan Type
        </Text>

        <SelectPlanTermForm
          onChange={setTermToUpdate}
          selectedTermValue={termToUpdate}
        />
      </EditModalWrapper>
    </>
  );
};
